import type { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

const postPasswordReset: DocumentNode = gql`
  mutation PostPasswordReset($code: String!, $password: String!) {
    postPasswordReset(input: { code: $code, password: $password }) {
      apiKey
      refreshToken
      message
    }
  }
`

export default postPasswordReset
